import { GlSkeletonLoader } from '@gitlab/ui';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
export default {
    name: 'SkeletonNote',
    components: {
        GlSkeletonLoader,
        TimelineEntryItem
    }
};
